module.exports = __webpack_public_path__ + "static/img/naverpay.52ffce3f.png";